import styled from "@emotion/styled";
import { css } from "@emotion/react";
import breakpoint from "@shared/styles/breakpoints";

const Subtitle = styled.h3((props) => {
  const t: any = props.theme;
  return css`
    ${[t.text.bold, t.mt(8)]}
    color: ${t.dark ? t.color.gray[200] : t.color.black};
    font-size: 1rem;
  `;
});

const PricingOptionsContainer = styled.div((props) => {
  const t: any = props.theme;
  return css`
    display: flex;
    flex-direction: column;
    ${[t.mt(9)]}
    max-width: 300px;

    ${breakpoint.sm} {
      max-width: 500px;
    }

    ${breakpoint.lg} {
      max-width: 755px;
    }
  `;
});

const PricingOptions = styled.div((props) => {
  const t: any = props.theme;
  return css`
    display: flex;
    flex-wrap: wrap;
    gap: ${t.spacing[3]};
    flex-direction: column;

    ${breakpoint.xs} {
      flex-direction: row;
    }
  `;
});


const Pricing = styled.div((props) => {
  const t: any = props.theme;
  return css`
    ${[t.rounded.md, t.p(4), t.mt(4)]};
    border: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[200]};
    background-color: ${t.dark ? t.color.gray[800] : "transparent"};
    color: ${t.dark ? t.color.gray[200] : t.color.black};
    flex: 1;
  `;
});

const PricingTitle = styled.div((props) => {
  const t: any = props.theme;
  return css`
    display: flex;
    ${[t.mb(4)]}
    align-items: center;
    flex-direction: row;

    h3 {
      ${[t.text.bold, t.text.sm, t.h(5)]}
      line-height: 1.3;
      &:first-letter {
        text-transform: uppercase;
      }
    }
  `;
});

const PricingPrice = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: AccountBilling_PricingPrice;
    ${[t.mb(5)]}
    display: flex;
    align-items: center;
    color: ${t.dark ? t.color.gray[200] : t.color.black};

    h4 {
      ${[t.text.bold]}
      font-size: 2rem;
    }

    span {
      display: inline-block;
      ${[t.text.normal, t.text.xs, t.ml(1)]}
      line-height: 1.4;
      color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    }
  `;
});

const ButtonWrapper = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: AccountBilling_ButtonWrapper;
    display: flex;

    button {
      ${t.mr(3)}

      &:last-of-type {
        ${t.mr(0)}
      }
    }
  `;
});

const Promo = styled.div((props) => {
  const t: any = props.theme;
  return css`
    ${[t.rounded.md, t.mb(3), t.px(4), t.py(3)]};
    border: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[200]};
    background-color: ${t.dark ? t.color.gray[800] : "transparent"};
    max-width: 1208px;

    h4 {
      ${[t.text.bold, t.mb(1)]};
      color: ${t.dark ? t.color.gray[200] : t.color.black};
    }

    span {
      ${[t.text.xs]}
      color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    }
  `;
});

const Badge = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: AccountBilling_PromoBadge;
    ${[t.h(4), t.ml(2), t.px(2)]};
    font-size: 0.625rem;
    color: ${t.color.black};
    background: linear-gradient(84.47deg, #fbd7ff 0%, #ffe4cc 100%, #ffdec1 100%);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    line-height: 1.3;
    height: 19px;
    border-radius: 5px;
  `;
});

const SavingsBadge = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: AccountBilling_PromoBadge;
    ${[t.ml(2), t.px(2)]};
    font-size: 0.625rem;
    color: ${t.dark ? t.color.gray[100] : t.color.black};
    background: ${t.dark ? t.color.gray[700] : t.color.gray[200]};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    line-height: 1.3;
    height: 19px;
    border-radius: 5px;
  `;
});

const SavingsIcon = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: AccountBilling_SavingsIcon;
    ${[t.ml(2)]}
    &:hover {
      cursor: auto;
    }

    svg {
      width: 15px;
      height: 15px;
      stroke: ${t.dark ? t.color.gray[500] : t.color.gray[600]};
    }
  `;
});

const CurrentSubscription = styled.div((props) => {
  const t: any = props.theme;
  return css`
    ${[t.rounded.md, t.py(3), t.mb(3), t.px(4)]};
    border: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[100]};
    background-color: ${t.dark ? t.color.gray[800] : t.color.gray[100]};
    color: ${t.dark ? t.color.gray[200] : t.color.black};
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    svg {
      flex-shrink: 0;
    }

    p {
      display: flex;
      align-items: center;
      gap: ${t.spacing[3]};

      span {
        color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
      }
    }

    button {
      margin-top: ${t.spacing[3]};
    }

    ${breakpoint.sm} {
      flex-direction: row;

      button {
        margin-top: 0;
        margin-right: ${t.spacing[3]};
      }
    }
  `;
});

const BillingPeriodToggleWrapper = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: AccountBillingPlans_BillingPeriodToggle;
    display: flex;
  `;
});

const ButtonsContainer = styled.div(() => {
  return css`
    label: PlanCard_ButtonsContainer;
    display: flex;
  `;
});

const ContentContainer = styled.div(() => {
  return css`
    label: PlanCard_ContentContainer;
    display: flex;
    flex-direction: column;
  `;
});

const PlanCardWrapper = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: PlanCard_CardWrapper;
    ${[t.p(5), t.rounded.md]}
    border: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[200]};
    background-color: ${t.dark ? t.color.gray[800] : t.color.white};
    position: relative;
    color: ${t.dark ? t.color.gray[300] : t.color.black};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    flex-grow: 1;
    height: 278px;

    button {
      ${t.mt(3)}
    }

    ${breakpoint.sm} {
      width: unset;
      min-width: 232px;
      max-width: 244px;
    }

    ${breakpoint.lg} {
      height: 300px;
    }
  `;
});

// _________________________________________
// Feature-related styled components
// _________________________________________

const Features = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: PlanCard_Features;
    ${t.mb(4)}
  `;
});

const Feature = styled.div((props: any) => {
  const t: any = props.theme;
  return css`
    label: PlanCard_Feature;
    ${[t.mb(3)]}
    display: flex;
    align-items: flex-start;
    color: ${t.dark ? t.color.gray[300] : t.color.gray[600]};

    svg {
      ${[t.mr(2)]}
      flex-shrink: 0;
      stroke: ${t.dark ? t.color.gray[200] : t.color.gray[500]}
      width: 13px;
      height: 13px;
    }

    .limitation {
      color: ${t.dark ? t.color.gray[300] : t.color.gray[400]};
    }
  `;
});

const FeatureContent = styled.div(() => {
  return css`
    label: PlanCard_FeatureContent;
    display: flex;
    flex-direction: column;
  `;
});

const FeatureName = styled.span((props) => {
  const t: any = props.theme;
  return css`
    label: PlanCard_FeatureName;
    ${[t.text.xs]}
    line-height: 1.4;

    svg {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-bottom: -2px;
      ${[t.ml(1)]}
    }
  `;
});

const FeatureValue = styled.span((props) => {
  const t: any = props.theme;
  return css`
    label: PlanCard_FeatureValue;
    ${[t.text.xs, t.mt(1)]}
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    font-style: italic;
  `;
});

export {
  Subtitle,
  PricingOptions,
  Pricing,
  PricingTitle,
  PricingPrice,
  ButtonWrapper,
  Badge,
  SavingsBadge,
  Promo,
  CurrentSubscription,
  BillingPeriodToggleWrapper,
  Features,
  Feature,
  FeatureContent,
  FeatureName,
  FeatureValue,
  ButtonsContainer,
  PlanCardWrapper,
  ContentContainer,
  SavingsIcon,
  PricingOptionsContainer,
};
